import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DeliveryAddressService } from '@checkout/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { DeviceService } from '@shared/services';
import { ModalService } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { SdvorDeliveryAddressListModalComponent } from './delivery-address-list-modal';
import { DeliveryState } from './delivery-address.model';

@Component({
  selector: 'sd-delivery-address-block',
  templateUrl: './delivery-address-block.component.html',
  styleUrls: ['./delivery-address-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorDeliveryAddressBlockComponent implements OnInit {
  state = DeliveryState;
  state$: Observable<DeliveryState>;
  iconType = CUSTOM_ICON_TYPE;

  constructor(
    private deliveryAddressService: DeliveryAddressService,
    private deviceService: DeviceService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.state$ = combineLatest({
      loading: this.deliveryAddressService.loading$,
      hasAddress: this.deliveryAddressService.hasActiveAddress$,
      isMobile: this.deviceService.isMobileSmDown$,
    }).pipe(
      map(({ loading, hasAddress, isMobile }) => {
        if (loading) {
          return this.state.Loading;
        }
        if (!hasAddress) {
          return this.state.AddAddress;
        }

        return isMobile ? this.state.ShowMobileAddress : this.state.ShowAddress;
      }),
    );
  }

  openDeliveryAddressListModal(): void {
    this.modalService.open(SdvorDeliveryAddressListModalComponent, { size: 'lg' });
  }
}
